module.exports = __webpack_public_path__ + "static/img/fd587c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/zkqq/东航金融二维码logo标准版.png
// module id = 712
// module chunks = 2